import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Image from '../components/contentDisplay/Image'
import Video from '../components/contentDisplay/Video'
import PDF from '../components/contentDisplay/PDF'
import IFrame from '../components/contentDisplay/IFrame'

const displayComponents = {
  Image,
  Video,
  PDF,
  IFrame
}

class ContentDisplay extends Component {
  render () {
    const {
      content,
      contentDisplayType
    } = this.props

    const Component = displayComponents[contentDisplayType]

    return <Component content={content} />
  }
}

ContentDisplay.propTypes = {
  content: PropTypes.string,
  contentDisplayType: PropTypes.string
}

export default ContentDisplay



// WEBPACK FOOTER //
// ./src/components/ContentDisplay.js